<template>
  <div class="aboutTabs__box">
    <div class="aboutTabs__box--nav">
      <div class="aboutTabs__box--column">
        <ul>
          <li :class="{active: (activeTab == 1)}">
            <a v-on:click="activeTab = 1">Strategy</a>
          </li>
          <li :class="{active: (activeTab == 2)}">
            <a v-on:click="activeTab = 2">Branding</a>
          </li>
          <li :class="{active: (activeTab == 3)}">
            <a v-on:click="activeTab = 3">Webdesign</a>
          </li>
        </ul>
        <ul>
          <li :class="{active: (activeTab == 4)}">
            <a v-on:click="activeTab = 4">Interface Design</a>
          </li>
          <li :class="{active: (activeTab == 5)}">
            <a v-on:click="activeTab = 5">User Experience</a>
          </li>
          <li :class="{active: (activeTab == 6)}">
            <a v-on:click="activeTab = 6">Development</a>
          </li>
        </ul>
      </div>
      <div class="aboutTabs__box--content">
        <span>
          <transition name="fadeTabsTitle" mode="out-in">
            <h2 v-if="activeTab == tabs[0].index" :key="tabs[0].title">{{ tabs[0].title }}</h2>
            <h2 v-if="activeTab == tabs[1].index" :key="tabs[1].title">{{ tabs[1].title }}</h2>
            <h2 v-if="activeTab == tabs[2].index" :key="tabs[2].title">{{ tabs[2].title }}</h2>
            <h2 v-if="activeTab == tabs[3].index" :key="tabs[3].title">{{ tabs[3].title }}</h2>
            <h2 v-if="activeTab == tabs[4].index" :key="tabs[4].title">{{ tabs[4].title }}</h2>
            <h2 v-if="activeTab == tabs[5].index" :key="tabs[5].title">{{ tabs[5].title }}</h2>
          </transition>
        </span>
        <span>
          <transition name="fadeTabsContent" mode="out-in">
            <p v-if="activeTab == tabs[0].index" :key="tabs[0].title">{{ tabs[0].content }}</p>
            <p v-if="activeTab == tabs[1].index" :key="tabs[1].title">{{ tabs[1].content }}</p>
            <p v-if="activeTab == tabs[2].index" :key="tabs[2].title">{{ tabs[2].content }}</p>
            <p v-if="activeTab == tabs[3].index" :key="tabs[3].title">{{ tabs[3].content }}</p>
            <p v-if="activeTab == tabs[4].index" :key="tabs[4].title">{{ tabs[4].content }}</p>
            <p v-if="activeTab == tabs[5].index" :key="tabs[5].title">{{ tabs[5].content }}</p>
          </transition>
        </span>
      </div>
    </div>

    <!-- <transition-group name="fadeTabs" tag="div"> -->
    <!-- <div v-for="tab in tabs" :key="tab.index"> -->
    <!-- </transition-group> -->
  </div>
</template>

<script>
export default {
  name: "AboutTabs",
  data() {
    return {
      activeTab: 1,
      tabs: [
        {
          index: 1,
          title: "Concepts which fit your strategy",
          content:
            "At Intervi, we weave together your marketing and advertising. We build a comprehensive strategy for your brand. We develop your concept and breathe life into it. We pay special attention to visual identification – to create projects that stand out from among the competition and encourage clients to get to know the brand better"
        },
        {
          index: 2,
          title: "Our idea for your branding",
          content:
            "A website is your showcase. Its design should impress, and its usability surprise with how easy it is to use. With us, you can be sure that your website is a combination of unique design and carefully crafted user experience. The online showcase we create combines audio, text, images, videos and unique graphic designs into a coherent product."
        },
        {
          index: 3,
          title: "Our idea for your website",
          content:
            "A website is your showcase. Its design should impress, and its usability surprise with how easy it is to use. With us, you can be sure that your website is a combination of unique design and carefully designed user experience. The online showcase we create combines audio, text, images, videos and unique graphic designs into a coherent product."
        },
        {
          index: 4,
          title: "Our idea for Interface Design",
          content:
            "The website has to be functional – this is how the brand can be sure that its users will get to know precisely what is offered, and will want to take advantage of it. The interfaces we design are distinguished by clear graphic design and ease of use. We are flexible and adapt to the changing needs of users, so that the interface is always readable and shows the character of the brand. "
        },
        {
          index: 5,
          title: "Our idea for User Experience",
          content:
            "We use our experience in website design to ensure that the users of our websites are only exposed to positive and unforgettable impressions. This is why we focus on high quality, inspiring design and efficient software. We design in such a way that website or application use is intuitive for the future user, and corresponds to the concept of the brand."
        },
        {
          index: 6,
          title: "Our idea for effective software development",
          content:
            "Our experts can create any software or application you need to facilitate your daily work. You can also count on us to help with the development of operating systems and database management systems. Our biggest advantage is the variety of programming languages we use. This enables us to develop systems, programs and applications for every industry."
        }
      ]
    };
  },
  props: []
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/AboutTabs.vue